const billing = {
  en: {
    'billing.title': 'Billing & Invoices',
    'billing.subtitle': 'Manage invoices and track payments',
    'billing.createInvoice': 'Create Invoice',
    'billing.createNewInvoice': 'Create New Invoice',
    'billing.totalRevenue': 'Total Revenue',
    'billing.pending': 'Pending',
    'billing.overdue': 'Overdue',
    'billing.totalInvoices': 'Total Invoices',
    'billing.searchInvoices': 'Search invoices...',
    'billing.allStatuses': 'All Statuses',
    'billing.allClients': 'All Clients',
    'billing.startDate': 'Start Date',
    'billing.invoices': 'Invoices',
    'billing.invoice': 'Invoice',
    'billing.client': 'Client',
    'billing.amount': 'Amount',
    'billing.status': 'Status',
    'billing.date': 'Date',
    'billing.dueDate': 'Due Date',
    'billing.dueDateOptional': 'Due Date (optional)',
    'billing.actions': 'Actions',
    'billing.download': 'Download',
    'billing.sendInvoice': 'Send Invoice',
    'billing.markSent': 'Mark as Sent',
    'billing.markPaid': 'Mark as Paid',
    'billing.delete': 'Delete',
    'billing.noInvoices': 'No invoices found',
    'billing.noInvoicesHint': 'Create your first invoice to get started.',
    'billing.selectClient': 'Select a client',
    'billing.clientRequired': 'Client is required',
    'billing.project': 'Project',
    'billing.selectProject': 'Select a project (optional)',
    'billing.amountRequired': 'Amount is required',
    'billing.amountMin': 'Amount must be greater than 0',
    'billing.amountOptionalHint': 'Leave blank to bill the project’s unbilled time.',
    'billing.unbilledLabel': 'Unbilled',
    'billing.noUnbilledTime': 'No unbilled time',
    'billing.description': 'Description',
    'billing.descriptionPlaceholder': 'Invoice description or notes...',
    'billing.includeTimeEntries': 'Include Time Entries',
    'billing.includeTimeEntriesHint': 'Include unbilled time entries for this project',
    'billing.cancel': 'Cancel',
    'billing.confirmSend': 'Are you sure you want to send this invoice?',
    'billing.confirmMarkSent': 'Mark this invoice as sent?',
    'billing.confirmMarkPaid': 'Mark this invoice as paid?',
    'billing.confirmDelete': 'Are you sure you want to delete this invoice? This action cannot be undone.',
    'billing.toastCreated': 'Invoice created successfully',
    'billing.toastCreateFailed': 'Failed to create invoice',
    'billing.toastSent': 'Invoice sent successfully',
    'billing.toastSendFailed': 'Failed to send invoice',
    'billing.toastMarkedSent': 'Invoice marked as sent',
    'billing.toastMarkSentFailed': 'Failed to mark invoice as sent',
    'billing.toastPaid': 'Invoice marked as paid',
    'billing.toastPaidFailed': 'Failed to mark invoice as paid',
    'billing.toastDeleted': 'Invoice deleted successfully',
    'billing.toastDeleteFailed': 'Failed to delete invoice',
    'billing.loadError': 'Failed to load billing data',
    'billing.statusDraft': 'Draft',
    'billing.statusSent': 'Sent',
    'billing.statusPaid': 'Paid',
    'billing.statusOverdue': 'Overdue',
    'billing.viewInvoice': 'View Invoice',
    'billing.invoiceDetails': 'Invoice Details',
    'billing.billTo': 'Bill To',
    'billing.issueDate': 'Issue Date',
    'billing.quantity': 'Qty/Hours',
    'billing.rate': 'Rate',
    'billing.subtotal': 'Subtotal',
    'billing.tax': 'Tax',
    'billing.discount': 'Discount',
    'billing.discountType': 'Discount Type',
    'billing.discountTypePercent': 'Percent (%)',
    'billing.discountTypeAmount': 'Fixed Amount',
    'billing.discountValue': 'Discount Value',
    'billing.taxRate': 'Tax Rate (%)',
    'billing.taxOptionalHint': 'Optional — leave blank for no tax.',
    'billing.taxLabel': 'Tax',
    'billing.total': 'Total',
    'billing.noItems': 'No line items',
    'billing.close': 'Close',
    'billing.downloadError': 'Could not download the invoice',
    'billing.notes': 'Notes',
    'billing.terms': 'Terms',
  },

  es: {
    'billing.title': 'Facturación y facturas',
    'billing.subtitle': 'Administra facturas y haz seguimiento de los pagos',
    'billing.createInvoice': 'Crear factura',
    'billing.createNewInvoice': 'Crear nueva factura',
    'billing.totalRevenue': 'Ingresos totales',
    'billing.pending': 'Pendiente',
    'billing.overdue': 'Vencida',
    'billing.totalInvoices': 'Total de facturas',
    'billing.searchInvoices': 'Buscar facturas...',
    'billing.allStatuses': 'Todos los estados',
    'billing.allClients': 'Todos los clientes',
    'billing.startDate': 'Fecha de inicio',
    'billing.invoices': 'Facturas',
    'billing.invoice': 'Factura',
    'billing.client': 'Cliente',
    'billing.amount': 'Importe',
    'billing.status': 'Estado',
    'billing.date': 'Fecha',
    'billing.dueDate': 'Fecha de vencimiento',
    'billing.dueDateOptional': 'Fecha de vencimiento (opcional)',
    'billing.actions': 'Acciones',
    'billing.download': 'Descargar',
    'billing.sendInvoice': 'Enviar factura',
    'billing.markSent': 'Marcar como enviada',
    'billing.markPaid': 'Marcar como pagada',
    'billing.delete': 'Eliminar',
    'billing.noInvoices': 'No se encontraron facturas',
    'billing.noInvoicesHint': 'Crea tu primera factura para empezar.',
    'billing.selectClient': 'Selecciona un cliente',
    'billing.clientRequired': 'El cliente es obligatorio',
    'billing.project': 'Proyecto',
    'billing.selectProject': 'Selecciona un proyecto (opcional)',
    'billing.amountRequired': 'El importe es obligatorio',
    'billing.amountMin': 'El importe debe ser mayor que 0',
    'billing.amountOptionalHint': 'Déjalo en blanco para facturar el tiempo no facturado del proyecto.',
    'billing.unbilledLabel': 'Sin facturar',
    'billing.noUnbilledTime': 'Sin tiempo sin facturar',
    'billing.description': 'Descripción',
    'billing.descriptionPlaceholder': 'Descripción o notas de la factura...',
    'billing.includeTimeEntries': 'Incluir entradas de tiempo',
    'billing.includeTimeEntriesHint': 'Incluir las entradas de tiempo no facturadas de este proyecto',
    'billing.cancel': 'Cancelar',
    'billing.confirmSend': '¿Seguro que quieres enviar esta factura?',
    'billing.confirmMarkSent': '¿Marcar esta factura como enviada?',
    'billing.confirmMarkPaid': '¿Marcar esta factura como pagada?',
    'billing.confirmDelete': '¿Seguro que quieres eliminar esta factura? Esta acción no se puede deshacer.',
    'billing.toastCreated': 'Factura creada correctamente',
    'billing.toastCreateFailed': 'No se pudo crear la factura',
    'billing.toastSent': 'Factura enviada correctamente',
    'billing.toastSendFailed': 'No se pudo enviar la factura',
    'billing.toastMarkedSent': 'Factura marcada como enviada',
    'billing.toastMarkSentFailed': 'No se pudo marcar la factura como enviada',
    'billing.toastPaid': 'Factura marcada como pagada',
    'billing.toastPaidFailed': 'No se pudo marcar la factura como pagada',
    'billing.toastDeleted': 'Factura eliminada correctamente',
    'billing.toastDeleteFailed': 'No se pudo eliminar la factura',
    'billing.loadError': 'No se pudieron cargar los datos de facturación',
    'billing.statusDraft': 'Borrador',
    'billing.statusSent': 'Enviada',
    'billing.statusPaid': 'Pagada',
    'billing.statusOverdue': 'Vencida',
    'billing.viewInvoice': 'Ver factura',
    'billing.invoiceDetails': 'Detalles de la factura',
    'billing.billTo': 'Facturar a',
    'billing.issueDate': 'Fecha de emisión',
    'billing.quantity': 'Cant./Horas',
    'billing.rate': 'Tarifa',
    'billing.subtotal': 'Subtotal',
    'billing.tax': 'Impuesto',
    'billing.discount': 'Descuento',
    'billing.discountType': 'Tipo de descuento',
    'billing.discountTypePercent': 'Porcentaje (%)',
    'billing.discountTypeAmount': 'Monto fijo',
    'billing.discountValue': 'Valor del descuento',
    'billing.taxRate': 'Tasa de impuesto (%)',
    'billing.taxOptionalHint': 'Opcional: déjalo en blanco para no aplicar impuesto.',
    'billing.taxLabel': 'Impuesto',
    'billing.total': 'Total',
    'billing.noItems': 'Sin líneas',
    'billing.close': 'Cerrar',
    'billing.downloadError': 'No se pudo descargar la factura',
    'billing.notes': 'Notas',
    'billing.terms': 'Términos',
  },
};

export default billing;
